import AsyncSelect from "react-select/async";
import { SearchFieldStyles } from "./SearchFieldStyles";
import servEquipamentos from "../../services/login/servEquipamentos";
import { useSelector } from "react-redux";
import { useContext, useEffect, useState } from "react";
import { EquipamentoContext } from "../../contexts/EquipamentoContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import styles from './Equipamentos.module.css';
import { components } from 'react-select';

const Option = props => (
    <components.Option {...props}>
        <div>
            <span style={{ fontSize: 14 }}>{props.label}</span>
            <br/>
            <span style={{ fontSize: 12 }}>{props.data.subtitle}</span>
        </div>
    </components.Option>
);

const EquipamentosSearchField = ({ value, setValue, id, setOpenError, setErrorMessage, onKeyDown, handleOpenLista=null, editavel }) => {
    const user = useSelector(state => state.user);
    const [key, setKey] = useState("key");
    const { codigoEquipamentoCtx, equipamentoCtx, salvarNovoEquipamento, equipamentoFoiEditado } = useContext(EquipamentoContext);

    useEffect(() => {
        if(!codigoEquipamentoCtx) return;

        // Modificando a key para que o componente de searchfield reconheça que houve mudanças
        // e que a listagem dos equipamentos seja realizada corretamente 
        // (quando um equipamento é cadastrado diretamente pelo orçamento de conexão)
        let keyAtualizada = key + new Date().toString();

        setKey(keyAtualizada);

        loadEquipamentos('');
    }, [codigoEquipamentoCtx, equipamentoCtx, salvarNovoEquipamento, equipamentoFoiEditado])

    const loadEquipamentos = async (inputValue) => {
        try {

            const response = await servEquipamentos.listarSArquivadas(user.codigoUsuario, inputValue);

            let data = response.Content.map(mapResponseToValuesAndLabels);

            return editavel ? data : [];

        } catch (err) {
            setOpenError(true);
            setErrorMessage(err?.response?.data?.Message);
        }
    }

    const retornaDescricaoNumeroFases = (numeroFases) => {
        let txtNumeroFases = "";

        switch (Number(numeroFases)) {
            case 1:
                txtNumeroFases = "Monofásica"
                break;
            case 2:
                txtNumeroFases = "Bifásica"
                break;
            case 3:
                txtNumeroFases = "Trifásica"
                break;
            default:
                break;
        }

        return txtNumeroFases;
    }

    const mapResponseToValuesAndLabels = (data) => {
        const tensaoFornecimento = data?.CodigoTensaoFornecimento ? `| Tensão nominal (V): ${data.CodigoTensaoFornecimento} - ${data.TensaoFornecimento.Descricao}` : '';
        
        return {
            value: data.Id,
            label: `${data.Descricao} (${data.Id})`,
            subtitle: `Modelo: ${data.Modelo} | Fases: ${retornaDescricaoNumeroFases(data.NumeroFases)} | Fabricante: ${data?.Fabricante ? data.Fabricante : data?.Fabricantes?.NomeFabricante} | Potência: ${data.PotenciaKw} kW ${tensaoFornecimento}`
        }
    }
    
    return (
        <div style={{  display: 'flex' }}>
            <AsyncSelect
                id={id}
                key={key}
                cacheOptions
                placeholder="Equipamento"
                loadOptions={loadEquipamentos}
                defaultOptions
                components={{Option}}
                styles={SearchFieldStyles}
                value={value}
                onChange={(data) => {
                    setValue(data);
                }}
                onKeyDown={onKeyDown}
            />
            <FontAwesomeIcon icon={faSearch} onClick={handleOpenLista} className={styles.searchfieldListaBtn} title="Abrir lista de equipamentos" />
        </div>
    )

}

export { EquipamentosSearchField };